import React, { useState, useEffect } from "react";

const Offers = () => {
  const [tableData, setTableData] = useState([]);

  // Fetch data from Google Sheets API
  const fetchTableData = async () => {
    try {
      const SHEET_ID = "15mb7KEKnSt0d3Q7Ih6nuju_PEN0cs1agSmckYmBND4E";
      const API_KEY = "AIzaSyAIrcGnQ2qVjIEScnNEbKFP35V6sgtQwPM";
      const RANGE = "Offers!A:B"; // Adjust based on your columns

      const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${RANGE}?key=${API_KEY}`;

      const response = await fetch(url);
      const data = await response.json();

      if (data.values) {
        setTableData(data.values.slice(1)); // Exclude header row
      }
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  // Fetch data on component mount and refresh every 10 seconds
  useEffect(() => {
    fetchTableData();
    const interval = setInterval(fetchTableData, 10000); // 10-second auto-refresh
    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);
  return (
    <>
      <section className="py-5" id="offers">
        <div className="container">
          <div className="row g-4 d-flex justify-content-center">
            <div className="col-12 col-md-8">
              <h2 className="mb-5 text-center">Limited-Time Offers</h2>
              <table className="table table-striped table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Offers-Выгодные поездки 🚕</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.length > 0 ? (
                    tableData.map((row, index) => (
                      <tr key={index}>
                        <td>{row[0]}</td>
                        <td>{row[1]}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2">No offers available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Offers;
